import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { filterUndefined } from 'src/app/lego-utils';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AdminService, SessionService } from 'src/app/state';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  public isAdmin$: Observable<boolean>;

  public constructor(
    private readonly adminService: AdminService,
    private readonly sessionService: SessionService,
    private readonly router: Router
  ) {
    this.isAdmin$ = this.sessionService.userShortName$.pipe(
      filterUndefined(),
      switchMap((id) => this.adminService.get(id)),
      map(() => true),
      catchError(() => of(false))
    );
  }

  public canActivate():
    Observable<UrlTree | boolean> | Promise<UrlTree | boolean> | UrlTree | boolean {
    return this.isAdmin$.pipe(
      map((isAdmin) => {
        if (!isAdmin) {
          return this.router.parseUrl('/error/403');
        }

        return isAdmin;
      })
    );
  }
}
